import {AuthoringQuestionSetModelV1} from 'resources/GeneratedModels/AuthoringQuestionSet/AuthoringQuestionSetModel.v1';

import {questionSetExtensions} from './questionSet.extensions';
import {authoringQuestionSetExtensions} from './authoringQuestionSet.extensions';

AuthoringQuestionSetModelV1.extend(questionSetExtensions, authoringQuestionSetExtensions);

export {AuthoringQuestionSetModelV1};
